"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Customizer Navigation Module
 */
var EpsilonCustomizerNavigation = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonCustomizerNavigation(control) {
        this.context = jQuery(control.container);
        this.multiple = this.context.find('.epsilon-customizer-navigation-container').length > 1;
        if (this.multiple) {
            this.initMultiple();
        }
        else {
            this.init();
        }
    }
    /**
     * Init multiple fields
     */
    EpsilonCustomizerNavigation.prototype.initMultiple = function () {
        var containers = this.context.find('.epsilon-customizer-navigation-container:not(.initiated)').first().addClass('initiated');
        containers.map(function (index, element) {
            jQuery(element).find('a').on('click', function (e) {
                e.preventDefault();
                if ('undefined' !== typeof (wp.customize.section(jQuery(this).attr('data-customizer-section')))) {
                    if (jQuery(e.target).attr('data-doubled')) {
                        wp.customize.section(jQuery(this).attr('data-customizer-section')).headContainer.trigger('click');
                    }
                    else {
                        wp.customize.section(jQuery(this).attr('data-customizer-section')).focus();
                    }
                }
            });
        });
    };
    /**
     * Control initiator
     */
    EpsilonCustomizerNavigation.prototype.init = function () {
        var navigation = this.context.find('.epsilon-customizer-navigation-container');
        if (navigation.length) {
            navigation.on('click', navigation.find('a'), function (e) {
                e.preventDefault();
                if ('undefined' !== typeof (wp.customize.section(jQuery(e.target).attr('data-customizer-section')))) {
                    if (jQuery(e.target).attr('data-doubled')) {
                        wp.customize.section(jQuery(e.target).attr('data-customizer-section')).headContainer.trigger('click');
                    }
                    else {
                        wp.customize.section(jQuery(e.target).attr('data-customizer-section')).focus();
                    }
                }
            });
        }
    };
    return EpsilonCustomizerNavigation;
}());
exports.EpsilonCustomizerNavigation = EpsilonCustomizerNavigation;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/customizer-navigation.ts
// module id = 5
// module chunks = 0